"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArbitrumRelayerFee = void 0;
const AbstractRelayerFee_1 = require("./AbstractRelayerFee");
const ethers_1 = require("ethers");
class ArbitrumRelayerFee extends AbstractRelayerFee_1.AbstractRelayerFee {
    constructor() {
        super(...arguments);
        this.getRelayCost = async () => {
            return ethers_1.BigNumber.from(0);
        };
    }
}
exports.ArbitrumRelayerFee = ArbitrumRelayerFee;
